/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 30.10.2014
 *   Time: 16:22
 */


export function bind(func: Function, owner: Object, ...args): Function {
    let bound: Function = function(...rest): any {
        return func.apply(owner, args.concat(rest));
    };

    return bound;
}

